/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import { FieldArrayRenderProps } from 'react-final-form-arrays'
import Button from '@mui/material/Button'
import FormHelperText from '@mui/material/FormHelperText'

import { Typography } from '@mui/material'
import { OnChange } from 'react-final-form-listeners'
import TableButtons from 'components/TableButtons'
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg'
import * as commonClasses from 'pagesNew/Questions/Form/AnswersFieldArray/styles'
import { InputField, NumberInputField } from 'components/Input'
import { validateRequired } from 'utils/validation'
import { FreeSoloAutocompleteField } from 'components/FreeSoloAutocompleteField'
import { EMPTY_RX_WRITING_ANSWER, RxWritingAnswer } from 'pagesNew/Questions/Form/RxWritingAnswers/helpers'
import * as classes from './styles'

export const MIN_ANSWERS_COUNT = 1

export const EMPTY_ANSWER = EMPTY_RX_WRITING_ANSWER

export type Props = {
  className?: string
  fields: FieldArrayRenderProps<Partial<RxWritingAnswer>, HTMLDivElement>['fields']
  meta: FieldArrayRenderProps<Partial<RxWritingAnswer>, HTMLElement>['meta']
  onAnswerChange: () => void
}

export const RxWritingAnswersFieldArray: FC<Props> = ({ className, fields, meta, onAnswerChange }) => {
  const error = Array.isArray(meta.error) ? meta.error[0] : meta.error

  return (
    <div className={className}>
      <div css={commonClasses.wrapper}>
        <OnChange name="rxWritingAnswer">{() => onAnswerChange()}</OnChange>
        {fields.length ? (
          fields.map((field, index) => (
            <div key={field} css={commonClasses.item}>
              <div css={[commonClasses.itemHeader, classes.itemHeader]}>
                <Typography css={classes.title}>Answer #{index + 1}</Typography>
                <div css={commonClasses.pointsWrapper}>
                  <Button
                    variant="outlined"
                    color="red"
                    size="small"
                    onClick={() => fields.remove(index)}
                    disabled={(fields.length ?? 0) <= MIN_ANSWERS_COUNT}
                    css={commonClasses.removeButton}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </div>

              <InputField
                name={`${field}.drug`}
                validate={validateRequired}
                label="Drug:"
                placeholder="Enter Drug"
                fullWidth
              />

              <FreeSoloAutocompleteField
                name={`${field}.strength`}
                label="Strength:"
                placeholder="Enter Text and hit Enter"
                validate={validateRequired}
              />

              <FreeSoloAutocompleteField
                name={`${field}.disp`}
                label="Disp.:"
                placeholder="Enter Text and hit Enter"
                validate={validateRequired}
              />

              <FreeSoloAutocompleteField
                name={`${field}.sig`}
                label="Sig.:"
                placeholder="Enter Text and hit Enter"
                validate={validateRequired}
              />

              <NumberInputField
                name={`${field}.repeat`}
                validate={validateRequired}
                label="Repeat"
                placeholder="Enter an integer"
                fullWidth
              />
            </div>
          ))
        ) : (
          <div css={commonClasses.empty}>No answers added</div>
        )}
      </div>

      <TableButtons itemName="Add New Answer" onAddItem={() => fields.push(EMPTY_ANSWER)} />
      {Boolean(meta.touched && error) && <FormHelperText error>{String(error)}</FormHelperText>}
    </div>
  )
}
